import { styled } from '@goodfynd/theme';
import { Menu, MenuItem } from '@mui/material';

import Container from '../layout/Container';

export const StyledAnchor = styled('div', {});

export const StyledMenu = styled(Menu, {
  '.MuiPaper-root': {
    borderRadius: 6,
    minWidth: 200,
    marginTop: 4,
    shadow: 2,
    '&.MuiMenu-list': {
      padding: '4px 0',
    },
    '&.MuiMenuItem-root': {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
});

export const StyledMenuItem = styled(MenuItem, {
  '&.MuiMenuItem-root': {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 24px',
    '&:hover': {
      color: 'var(--TextIconPrimary)',
      svg: {
        color: 'var(--TextIconPrimary)',
      },
      '.MuiTypography-root': {
        color: 'var(--TextIconPrimary)',
      },
    },
  },
});

export const StyledMenuLabel = styled('span', {
  alignItems: 'center',
  display: 'flex',
  '.MuiAvatar-root': {
    marginRight: 8,
  },
  svg: {
    marginRight: 8,
  },
});

export const StyledContainer = styled(Container, {
  '&.MuiContainer-root': {
    '@sm': {
      paddingLeft: 0,
      paddingRight: 0,
      paddgingTop: 0,
    },
    '@md': {
      paddingTop: 32,
    },
  },
});
